import React, {Suspense} from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./components/home";
import Consulting from "./components/consulting";
import PageNotFound from "./components/404";
import ListSSM from "./page/list-ssm";
import SimulationSSM from "./page/simulation-ssm";
import Parigi from "./page/parigi";

const App = () => {
    return (
        <Suspense fallback="loading">
            <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<Home/>}/>
                    <Route exact path="/consulting" element={<Consulting/>}/>
                    <Route exact path="/ssm" element={<ListSSM/>}/>
                    <Route exact path="/ssm-simulation/:id" element={<SimulationSSM/>}/>
                    <Route exact path="/giorgia" element={<Parigi/>}/>
                    <Route path="*" element={<PageNotFound/>}/>
                </Routes>
            </BrowserRouter>
        </Suspense>
    );
}

export default App;
